import { render } from "./getPerformanceVerification.vue?vue&type=template&id=23aee274&scoped=true"
import script from "./getPerformanceVerification.vue?vue&type=script&lang=js"
export * from "./getPerformanceVerification.vue?vue&type=script&lang=js"

import "./getPerformanceVerification.vue?vue&type=style&index=0&id=23aee274&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aee274"]])

export default __exports__